import { render, staticRenderFns } from "./WindowsButtons.vue?vue&type=template&id=07a80663"
import script from "./WindowsButtons.vue?vue&type=script&lang=ts"
export * from "./WindowsButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports